import { useQuery } from '@tanstack/react-query'

import { API } from '@/api'
import { GetNATListReq } from '@/api/type-request'
import { useUnifiedContext } from '@/contexts/UnifiedContext'

interface UseNATListQueryParams {
  params: GetNATListReq
  enabled?: boolean
}

export function useNATListQuery({ params, enabled = true }: UseNATListQueryParams) {
  const ctx = useUnifiedContext()

  const queryResult = useQuery({
    queryKey: ['natList', ctx.mode, ctx.teamResID, ctx.memberResID, params],
    queryFn: async ({ signal }) => {
      const res = await API.getNATList(params, { signal })
      if (res.code !== 0) {
        throw new Error(res.msg || 'Failed to fetch NAT list')
      }
      return {
        networks: res.networks ?? [],
        pagination: res.pagination,
      }
    },
    enabled,
  })

  return {
    networks: queryResult.data?.networks ?? [],
    pagination: queryResult.data?.pagination,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  }
}
